<ion-header></ion-header>
<ion-content class="login-content" id="background">
  <div class="login-title">{{ 'AUTHENTICATION.TITLE' | translate }}</div>
  <div class="login-box">
    <ion-row>
      <ion-col>
        <ion-button
          (click)="authenticateUser()"
          expand="block"
          color="orange"
          [disabled]="loginPending() === 'LOGIN_STARTED'"
        >
          <ion-label class="submit-btn">{{ 'AUTHENTICATION.BUTTON' | translate }}</ion-label>
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
<ion-footer class="ion-no-border">
  <div class="titre" color="dark">{{ fullAppVersion() }}</div>
</ion-footer>
